<div *ngIf="modalIsOpen" class="transfer-modal">
  <div class="h-100">
    <a href="#" class="icon close" (click)="handleClose(); $event.preventDefault()"
      ><img src="/assets/images/icon/close.svg"
    /></a>
    <div class="row h-100">
      <div class="col-12 col-lg-6">
        <div class="p-5 h-100">
          <p class="title">Select Tools to Transfer</p>
          <app-tool-id-transfer-search #transferIdSearch></app-tool-id-transfer-search>
          <app-tool-transfer-search #transferSearch></app-tool-transfer-search>
          <div class="selected">
            <div class="d-flex justify-content-between align-items-center">
              <p>
                <strong>Selected Tools ({{ tableData.data.length }})</strong>
              </p>
              <button (click)="handleClear()">Clear</button>
            </div>
            <app-tool-settings-table
              class="scroll"
              [headers]="tableData"
              [rows]="tableData.data"></app-tool-settings-table>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 border-left">
        <div class="p-5 h-100">
          <p class="title small">Choose Where You Want to Transfer Tools</p>
          <p class="body">
            You can transfer selected tools to another job, employee, location, or shop. This action is will update all
            tools choosen.
          </p>
          <app-tool-transfer-assignment></app-tool-transfer-assignment>
        </div>
      </div>
    </div>
  </div>
</div>
